import { Component, OnInit } from '@angular/core';
import { IndexedBookingSetDTO } from '../../../services/api/api';
import { ModalNavigationService } from '../../../services/gui/modal/modal-navigation.service';
import { ModalNavigationComponent } from '../../../services/gui/modal/modal-navigation-component';

@Component({
  selector: 'app-targeted-booking-set',
  templateUrl: './targeted-booking-set.component.html',
  styleUrls: ['./targeted-booking-set.component.scss'],
  standalone: false,
})
export class TargetedBookingSetComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;
  bookingSet: IndexedBookingSetDTO;

  constructor(public modalNavigationService: ModalNavigationService) {
    this.bookingSet = null;
  }

  ngOnInit() {
    if (this.isInModalContext) {
      this.bookingSet = this.modalNavigationService.getCurrentNavigation().data.bookingSet;
    }
  }
}
